import React from 'react';

import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import Tooltip from 'components/application/Tooltip';

const MAX_NAMES_SHOWN = 10;

export default function SharedContentBadge({
  areAllVisible,
  recordName,
  sharedNames,
  variant,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'contentRegister.components.SharedContentBadge',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const visibleNames = sharedNames.slice(0, MAX_NAMES_SHOWN);
  const additionalCount = Math.max(sharedNames.length - MAX_NAMES_SHOWN, 0);

  return (
    <Tooltip
      className='tooltip-dark--max-w-xs'
      placement='top'
      tooltip={
        <div className='tw-text-left'>
          <div>
            <Trans
              components={{ span: <span className='tw-font-semibold' /> }}
              i18nKey={`contentRegister.components.SharedContentBadge.sharedAcross.${variant}`}
              ns='components'
              tOptions={{ interpolation: { escapeValue: false } }}
              values={{ name: recordName }}
            />
          </div>
          {visibleNames.length > 0 && (
            <ul className='tw-m-0'>
              {visibleNames.map((name) => (
                <li key={name}>{name}</li>
              ))}
            </ul>
          )}
          {additionalCount > 0 && (
            <span className='tw-ml-3'>
              {i18nTShared('other', { count: additionalCount })}
            </span>
          )}
          {!areAllVisible && (
            <div>{i18nT(`inaccessible.${variant}`, { name: recordName })}</div>
          )}
        </div>
      }
      trigger='hover'
      triggerProps={{ className: 'tooltip-trigger tw-truncate tw-w-max' }}
    >
      <div
        className='tw-truncate tw-whitespace-nowrap tw-rounded-lg tw-bg-cyan-025 tw-px-2 tw-py-1 tw-text-s tw-font-medium tw-tracking-wide tw-text-cyan-800'
        data-element-name='shared-content-badge'
      >
        {i18nT(`label.${variant}`)}
      </div>
    </Tooltip>
  );
}

SharedContentBadge.propTypes = {
  areAllVisible: PropTypes.bool.isRequired,
  recordName: PropTypes.string.isRequired,
  sharedNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  variant: PropTypes.oneOf(['categories', 'divisions']).isRequired,
};
